import type { SystemBattleBotsConfig } from "../schemas"
import { SystemBattleBotsConfigSchema } from "../schemas"
import { DEFAULT_SYSTEM_BATTLE_BOTS_CONFIG } from "./battleBots"

export const SYSTEM_BATTLE_BOTS_STORAGE_KEY = "craft-force.system-battle-bots"
export const SYSTEM_BATTLE_BOTS_STORAGE_VERSION = 1

export const SystemBattleBotsStateSchema = SystemBattleBotsConfigSchema

export const EMPTY_SYSTEM_BATTLE_BOTS: SystemBattleBotsConfig =
  DEFAULT_SYSTEM_BATTLE_BOTS_CONFIG
